export default __webpack_public_path__ + "static/media/ss-unten.497f43df.jpg";